import Fuel from './fuelIcon'
import Incidentals from './incidentalsIcon'
import ReplacementTyres from './replacementTyresIcon'
import RoadsideAssistance from './roadsideAssistanceIcon'
import ScheduledMaintenance from './scheduledMaintenanceIcon'
import ComprehensiveInsurance from './comprehensiveInsuranceIcon'
import AnnualRegistration from './annualRegistrationIcon'
import LeaseFees from './leaseFeesIcon'
import Electricity from './electricityIcon'

export default {
  Fuel,
  Incidentals,
  ReplacementTyres,
  ScheduledMaintenance,
  RoadsideAssistance,
  ComprehensiveInsurance,
  AnnualRegistration,
  LeaseFees,
  Electricity,
}
